import React, { useEffect, useRef, useState } from 'react'
import FilterListIcon from '@mui/icons-material/FilterList'
import {
  Box,
  Button,
  Menu,
  Paper,
  SxProps,
  Theme,
  Typography
} from '@mui/material'

import { StyleIconButton } from '../../pages/Vouchers/Vendor/Faber/Components/FaberVouchersTable'

import CustomFilterSection from './CustomFilterSection'

export default function CustomDataGridServerFiter(props: ServerFilterProps) {
  const { filterFields, setFilterActive, menuSx } = props
  const [activeCheckBoxes, setActiveCheckBoxes] = useState<number>(0)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const divRef = useRef<HTMLDivElement>(null)
  const open = Boolean(anchorEl)

  const handleFilterClick = () => {
    setAnchorEl(divRef.current)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const checkedFilterFields = filterFields.filter((field) => {
    return field.checked.length > 0
  })

  if (checkedFilterFields.length > 0) {
    setFilterActive(true)
  } else {
    setFilterActive(false)
  }

  useEffect(
    () => {
      const count = () => {
        let checkboxCount = 0
        filterFields.forEach((field) => {
          checkboxCount += field.checked.length
        })
        return checkboxCount
      }
      setActiveCheckBoxes(count())
    },
    filterFields.map((field) => field.checked)
  )

  const resetFilter = () => {
    setFilterActive(false)
    filterFields.forEach((field) => {
      field.setChecked([])
    })
  }

  return (
    <Box sx={{ width: '200px' }}>
      <StyleIconButton onClick={handleFilterClick}>
        <div ref={divRef}>
          <FilterListIcon />
        </div>
        <Typography sx={{ color: 'primary.main' }}>
          {' '}
          Filter {activeCheckBoxes > 0 ? `(${activeCheckBoxes})` : ''}
        </Typography>
      </StyleIconButton>

      <Paper sx={{ width: '100%' }}>
        <Menu
          id='basic-menu'
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          sx={{ position: 'absolute', ...menuSx }}
        >
          <Box sx={{ margin: '0 16px' }}>
            {filterFields.map((filterField, index) => (
              <CustomFilterSection key={index} filterField={filterField} />
            ))}
          </Box>
          <Button
            variant='outlined'
            onClick={resetFilter}
            sx={{
              fontWeight: 400,
              ml: '20px',
              mt: '-10px',
              color: '#333333',
              borderColor: '#333333',
              borderWidth: '1px',
              height: '30px',
              px: '12px',
              py: '6px'
            }}
          >
            Reset
          </Button>
        </Menu>
      </Paper>
    </Box>
  )
}

export interface ServerFilterProps {
  filterFields: IServerFilterField[]
  filterActive: boolean
  setFilterActive: React.Dispatch<React.SetStateAction<boolean>>
  menuSx?: SxProps<Theme> | undefined
}

export interface IServerFilterField {
  name: string
  index: string
  values: string[]
  checked: string[]
  setChecked: React.Dispatch<React.SetStateAction<string[]>>
}
